export default __webpack_public_path__ + "static/media/G0020.34I-25844_-15911_0.484ac386.jpg";